<i18n>
{
  "de": {
    "resetTitle": "Passwort zurücksetzen",
    "enterEmailForNewPassword": "Bitte gib Deine E-Mail-Adresse ein. Wir senden Dir dann einen Link zu, damit Du ein neues Passwort setzen kannst.",
    "email": "E-Mail-Adresse",
    "sendRecoveryLink": "Wiederherstellungslink zusenden",
    "cancel": "Abbrechen",
    "recoveryLinkSent": "Wir haben einen Wiederherstellungs-Link für Dein Passwort erstellt und ihn Dir an <b>{email}</b> zugeschickt.<br><br>Bitte prüfe auch zur Sicherheit Deinen Spam-Ordner.<br>Wenn Du in ein paar Minuten noch keine E-Mail von uns erhalten hast, wiederhole diesen Vorgang.",
    "resendRecoveryLink": "Wiederherstellungslink erneut senden"
  },
  "en": {
    "resetTitle": "Reset Password",
    "enterEmailForNewPassword": "Please enter your email address. We will send you a link to reset your password.",
    "email": "Email Address",
    "sendRecoveryLink": "Send Recovery Link",
    "cancel": "Cancel",
    "recoveryLinkSent": "We have sent a link to <b>{email}</br> to setup a new password for your account.<br><br>Please also check your SPAM-Folder.<br>In case you did not receive that email within a couple of minutes, please try to resend it.",
    "resendRecoveryLink": "Resend Recovery Link"
  }
}
</i18n>

<template>
  <div>
    <div class="columns">
      <div class="column is-4 is-offset-4 mdc-theme--light">
        <h3 class="title is-2">
          {{ $t('resetTitle') }}
        </h3>
        <form
          v-if="!send"
          novalidate
          method="post"
          @submit.prevent="submitRecovery"
        >
          <p class="has-text-grey">
            {{ $t('enterEmailForNewPassword') }}
          </p>

          <input-text
            id="email"
            v-model="email"
            :label="$t('email')"
            name="email"
            validate="required|validEmailAddress"
          />

          <div class="control mt-50">
            <button
              type="submit"
              :disabled="errors.any()"
              class="button is-primary is-outlined is-fullwidth is-medium"
            >
              {{ $t('sendRecoveryLink') }}
            </button>

            <nuxt-link
              :to="localePath({ name: 'portal-login' })"
              class="button is-secondary mt-20 is-outlined is-fullwidth is-medium"
            >
              {{ $t('cancel') }}
            </nuxt-link>
            <input
              type="submit"
              style="position: absolute; left: -9999px"
            >
          </div>
        </form>

        <div v-else>
          <p
            class="has-text-grey"
            v-html="$t('recoveryLinkSent', { email: email })"
          />

          <a
            class="button is-primary mt-20 is-outlined is-fullwidth is-medium"
            @click.prevent="resendRecovery"
          >{{
            $t('resendRecoveryLink') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  inject: ['$validator'],

  data: () => ({
    title: 'Reset Password',
    email: '',
    send: false
  }),

  head() {
    return {
      title: this.title
    }
  },

  mounted() {
    this.$validator.localize(this.$i18n.locale)
  },

  methods: {
    async submitRecovery() {
      const valid = await this.$validator.validateAll()
      if (valid) this.resendRecovery()
    },
    async resendRecovery() {
      const data = await this.apiPost('/api/private/password-recovery', this.$data)
      if (data.ok) {
        this.send = true
      }
      if (data.error) {
        this.errorMessage('Unable to request password reset for that address.')
      }
    }
  }
}
</script>
